import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/my-invoices',
    name: 'MyInvoicesPage',
    component: () => import('@/modules/myInvoices/views/MyInvoicesPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
